import {
    Section
} from './styles';

const UserContainer = props => (
    <Section>
        {props.children}
    </Section>
);

export default UserContainer;